import { useState } from 'react';
import { Link } from 'react-router-dom';
import { MdClose, MdMenu, MdPersonAdd } from 'react-icons/md';
import ThemeToggle from '../ThemeToggle';
import LanguageSelector from '../LanguageSelector';
import { t } from '../../utils/i18n';
import logoImage from '../../assets/babysit_logo.png';

export default function LandingHeader({ onOpenAuth }) {
  const [open, setOpen] = useState(false);

  const auth = (mode) => {
    setOpen(false);
    onOpenAuth(mode);
  };

  return (
    <header className="landing-header">
      <div className="landing-container landing-header-inner">
        <Link to="/" className="landing-logo-mark">
          <img src={logoImage} alt="Nannity" className="h-9 w-auto" />
          <span className="landing-logo-text">Nannity</span>
          <span className="landing-logo-badge">{t('landing.header.badge')}</span>
        </Link>

        <div className="landing-nav-actions">
          <LanguageSelector />
          <ThemeToggle />
          <button type="button" onClick={() => onOpenAuth('login')} className="landing-btn-ghost ml-1">
            {t('landing.header.login')}
          </button>
          <button type="button" onClick={() => onOpenAuth('register')} className="landing-btn-cta ml-1">
            {t('landing.header.register')}
          </button>
        </div>

        <div className="md:hidden flex items-center gap-1">
          <ThemeToggle />
          <button
            type="button"
            onClick={() => setOpen(!open)}
            className="landing-btn-ghost p-2"
            aria-label={t('nav.accountMenu')}
            aria-expanded={open}
          >
            {open ? <MdClose className="text-xl" /> : <MdMenu className="text-xl" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-[var(--lp-border)] bg-[var(--lp-surface)]">
          <div className="landing-container py-3 space-y-2">
            <div className="flex items-center justify-between py-2">
              <span className="text-sm text-[var(--lp-text-muted)]">{t('nav.language')}</span>
              <LanguageSelector />
            </div>
            <button type="button" onClick={() => auth('login')} className="w-full landing-btn-ghost py-2.5">
              {t('landing.header.login')}
            </button>
            <button type="button" onClick={() => auth('register')} className="w-full landing-btn-cta py-2.5 flex items-center justify-center gap-2">
              {t('landing.header.register')}
              <MdPersonAdd />
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
